<script>
    import { onMount } from "svelte";
  
    export let label = "";
    export let fieldName = "";
    export let value = "";
    export let required = false;
    export let selectOptions = [];
    export let labelField = "text";
    export let valueField = "value";
    export let compact = false;
  
    const inputID = Math.random().toString(36).slice(2, 12);
  
    onMount(() => {
      if (typeof value !== 'string') {
        value = value.toString();
      }
      if (value == "" || value == null || value == undefined) {
        value = selectOptions[0][valueField];
      }
      console.log("value: ", value, typeof value);
    });
  
  </script>
  
  {#if label}
    <label class="form-label" for={inputID}>
      {label}
      {#if required}
        <span class="text-red">*</span>
      {/if}
    </label>
  {/if}
  <select
    class="default-select form-control wide"
    class:compact={compact}
    name={fieldName}
    id={inputID}
    {required}
    bind:value
  >
    {#each selectOptions as selectOption}
      <option value={selectOption[valueField]}>{selectOption[labelField]}</option>
    {/each}
  </select>
  